export default function inputArrowControls(selector) {
  const inputParentArray = document.querySelectorAll(selector)

  inputParentArray.forEach(inputParent => {
    const input = inputParent.querySelector('input[type="number"]')
    const arrowIncrement = inputParent.querySelector('.arrow-up')
    const arrowDecrement = inputParent.querySelector('.arrow-down')
    let intervalId;
    const intervalSpeed = 100

    input.addEventListener('keydown', onKeyDown)

    arrowIncrement.addEventListener('pointerdown', (event) => {
      onPointerdown.call(input, 'up')
      intervalId = setInterval(onPointerdown.bind(input, 'up'), intervalSpeed)
    })
    arrowDecrement.addEventListener('pointerdown', (event) => {
      onPointerdown.call(input, 'down')
      intervalId = setInterval(onPointerdown.bind(input, 'down'), intervalSpeed)
    })

    document.addEventListener('pointerup', onPointerup)

    function onPointerup() {
      clearInterval(intervalId)
    }

    function onPointerdown(arrow, event) {
      if (arrow === 'up') {
        increment(this)
      }
      else if (arrow === 'down') {
        decrement(this)
      }
      this.dispatchEvent(new Event('input'))
    }

    function increment(input) {
      const max = input.max === '' ? 99 : Number(input.max)
      if (Number(input.value) < max) {
        input.value = ++input.value
      }
    }

    function decrement(input) {
      const min = input.min === '' || input.min < 1 ? 1 : Number(input.min)
      if (Number(input.value) > min) {
        input.value = --input.value
      }
    }

    function onKeyDown(event) {
      // if (event.code === "ArrowUp" || event.code === "ArrowDown") return
      // event.preventDefault()
    }

  });
}